module.exports = __webpack_public_path__ + "media/hk_3F RM5.14e6f34d.mp4";